import { HOME_SET_VIEW_ROLE } from '@core/constants/actions';
import { HomeViewRole } from '@app/constants/home';

const setHomeViewRole = (viewRole: HomeViewRole) => {
  try {
    localStorage.setItem('homeViewRole', viewRole);
  } catch (error) {
    // Ignore localStorage errors
  }

  return {
    type: HOME_SET_VIEW_ROLE,
    viewRole,
  };
};

export default setHomeViewRole;
